import { UserException } from '@/domain/user/exception/UserException'

export class CannotSendInvitationUserException extends UserException {

}
